import { render, staticRenderFns } from "./GameBoard.vue?vue&type=template&id=61ad243f&scoped=true&"
import script from "./GameBoard.vue?vue&type=script&lang=js&"
export * from "./GameBoard.vue?vue&type=script&lang=js&"
import style0 from "./GameBoard.vue?vue&type=style&index=0&id=61ad243f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ad243f",
  null
  
)

export default component.exports